// import img_china from '../img/event1_china.jpg';
// import img_italy from '../img/event1_italy.jpg';
// import img_canada from '../img/event1_canada.jpg';
// [![](${img_china})](http://www.nbcolympics.com/video/rio-china-wins-diving-gold-synchronized-3m-springboard)
// [![](${img_italy})](http://www.nbcolympics.com/video/italy-takes-diving-silver-synchronized-3m-springboard)
// [![](${img_canada})](http://www.nbcolympics.com/video/canada-narrowly-fails-unseat-australia-bronz-medal)

export default `

`.trim();



/** WEBPACK FOOTER **
 ** ./src/notes/event1.md.js
 **/